import { render, staticRenderFns } from "./DeletePropertyCommunity.vue?vue&type=template&id=5fe1a74b"
import script from "./DeletePropertyCommunity.vue?vue&type=script&lang=js"
export * from "./DeletePropertyCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports